import { CurrencyCode } from '@src/constants';

export const BASE_RISK = 'Tour_Medical_Expenses';
export const EXCLUDE_OPTIONS = ['Tour_Drugs', 'Tour_Phone'];
export const CURRENCY_MAP = {
  [CurrencyCode.RUB]: '₽',
  [CurrencyCode.EUR]: '€',
  [CurrencyCode.USD]: '$',
};
